const GIFT_SETTING_FIELD_NAME = "ギフトラッピング（+550円）";

// ギフト設定の監視が必要かどうか
let hasGiftSettings = false;
let isGiftSettingMonitoringRequired = false;
// ギフト用のバリデーション
function checkGiftSettings() {
  const needNoshi = document.querySelector(
    'input[name="properties[熨斗]"]:checked'
  );
  const noshiSetting = document.querySelector(
    'textarea[name="properties[内容]"]'
  );
  if (needNoshi.value === "希望する" && noshiSetting.value == "") {
    disableSubmitButton();
  } else {
    enableSubmitButton();
  }
}
// erabino商品用のバリデーション
function checkErabinoForm() {
  const card = document.querySelector('select[name="properties[カード]"]');
  if (card.value == "") {
    disableSubmitButton();
    return;
  }
  if (card.value == "originalメッセージ") {
    const message = document.querySelector(
      'textarea[name="properties[originalメッセージの内容]"]'
    );
    if (message.value == "") {
      disableSubmitButton();
      return;
    }
  }
  const noshi = document.querySelector('select[name="properties[熨斗]"]');
  if (noshi.value == "希望する") {
    const noshiSetting = document.querySelector(
      'textarea[name="properties[内容]"]'
    );
    if (noshiSetting.value == "") {
      disableSubmitButton();
      return;
    }
  }
  enableSubmitButton();
}

// Submit ボタンを非活性にする
function disableSubmitButton() {
  const submitButton = document.querySelector(
    '.product-form__buttons button[type="submit"]'
  );
  const paymentButton = document.querySelector(".shopify-payment-button");
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.style.pointerEvents = "none";
    submitButton.style.opacity = 0.25;
  }
  if (paymentButton) {
    paymentButton.style.pointerEvents = "none";
    paymentButton.style.opacity = 0.4;
  }
}
// Submit ボタンを活性化する
function enableSubmitButton() {
  const submitButton = document.querySelector(
    '.product-form__buttons button[type="submit"]'
  );
  const paymentButton = document.querySelector(".shopify-payment-button");
  if (submitButton) {
    submitButton.disabled = false;
    submitButton.style.pointerEvents = "auto";
    submitButton.style.opacity = 1;
  }
  if (paymentButton) {
    paymentButton.style.pointerEvents = "auto";
    paymentButton.style.opacity = 1;
  }
}

// InfiniteOptions アプリを取得
"Shoppad.apps.infiniteoptions".split(".").reduce(function (o, x) {
  if (!o[x]) {
    o[x] = {};
  }
  return o[x];
}, window);

// Define beforeReady callback
window.Shoppad.apps.infiniteoptions.beforeReady = function (subscribe) {
  subscribe("appLoad", function (event) {
    console.log("appLoad", event);
  });
  subscribe("fieldLoad", function (event) {
    if (event.detail.name === GIFT_SETTING_FIELD_NAME) {
      hasGiftSettings = true;
    }
  });
  subscribe("fieldChange", function (event) {
    if (hasGiftSettings) {
      // ギフト設定がある場合のチェック
      if (event.detail.name === GIFT_SETTING_FIELD_NAME) {
        if (event.detail.value === "あり") {
          isGiftSettingMonitoringRequired = true;
          checkGiftSettings();
        } else {
          isGiftSettingMonitoringRequired = false;
          enableSubmitButton();
        }
      } else {
        if (isGiftSettingMonitoringRequired) checkGiftSettings();
      }
    } else if (isErabinoProduct) {
      // erabino商品の場合のチェック
      checkErabinoForm();
    }
  });
};
